export const InputLabelStyle = [
  {
    backgroundColor: "transparent",
    display: "flex",
    alignSelf: "baseline",
    textTransform: "none",
    position: "initial",
    transform: "translateX(0px) translateY(0px)",
    fontFamily: "Rubik",
    fontWeight: 500,
    fontSize: 14,
    color: "#333",
  },
];

export const seriesStyles = {
  border: "1px solid #8c8c8c",
  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: "3px",
    "& legend": {
      width: 0,
    },
  },
  "& .MuiOutlinedInput-root": {
    padding: 0,
  },
};
